import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogComposerAttachmentsInvalidItem from './VeltCommentDialogComposerAttachmentsInvalidItem/VeltCommentDialogComposerAttachmentsInvalidItem';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentDialogComposerAttachmentsInvalid = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsInvalid.Item = VeltCommentDialogComposerAttachmentsInvalidItem;
export default VeltCommentDialogComposerAttachmentsInvalid;
